module.exports = __webpack_public_path__ + "static/media/dash-warning-icon.6d3a4b84.svg";